import React from 'react';
import { SUCCESS__24, ADD_CIRCLE__24 } from '@homeaway/svg-defs';
import { SVGIcon } from '@homeaway/react-svg';
import "./Caption.css";
export default function Caption(props) {
  var icon = props.icon,
      message = props.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "Caption"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Caption__icon"
  }, icon === 'do' && /*#__PURE__*/React.createElement(SVGIcon, {
    className: "Caption__icon--do text-success",
    inlineFlex: true,
    markup: SUCCESS__24
  }), icon === 'dont' && /*#__PURE__*/React.createElement(SVGIcon, {
    className: "Caption__icon--dont text-danger",
    inlineFlex: true,
    markup: ADD_CIRCLE__24
  }), icon === 'target' && /*#__PURE__*/React.createElement("div", {
    className: "Caption__icon--target"
  })), /*#__PURE__*/React.createElement("div", {
    className: "Caption__message"
  }, message));
}
//# sourceMappingURL=Caption.js.map